import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../../app/shared/_services/api.service';
import { MetaService } from '@ngx-meta/core';

@Component({
  selector: 'app-contatti',
  templateUrl: './contatti.component.html',
  styles: []
})
export class ContattiComponent implements OnInit {

  constructor(private api: ApiService, private meta: MetaService) {
    this.isMobile = window.innerWidth < environment.mobileBreakpoint;
   }

  @ViewChild('recaptcha', {static: true }) recaptchaElement: ElementRef;

  contatto: any = {};
  errore = false;
  showModal = false;
  showSubmit = false;
  isMobile = false;


  ngOnInit() {
    this.meta.setTag('description', 'CONTATTI_DESCRIPTION');
    this.meta.setTitle('CONTATTI_TITLE');
  }

  inviaContatto() {
    this.api.paginaContactUs(this.contatto).subscribe((res: any) => {
      if (res.esito === 'OK') {
        this.showModal = true;
      } else {
        this.errore = true;
      }
    });
  }

  resolved(event) {
    this.showSubmit = event;
  }

  openFacebook() {
    
    const userAgent = navigator.userAgent || navigator.vendor;

    if (this.isMobile && /iPad|iPhone|iPod/.test(userAgent)) {
      setTimeout(() => {
        window.location.href = 'https://www.facebook.com/stemtechnology';
      }, 25);
      window.location.href = 'fb://profile/?id=stemtechnology';
    } else {
      window.open(
        'https://www.facebook.com/stemtechnology',
        '_blank',
      );
    }
  }
}
